module.exports = __webpack_public_path__ + "static/media/logout.6e32f1de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logout.svg
// module id = 772
// module chunks = 0